import { useDispatch } from "react-redux";
import { useState } from "react";
import { removeAdminImage } from "../../../store/slices/AdminSlice/AdminSlice";

export default function DisplayImage({
  src,
  id,
  label,
  action,
  onEdit,
  startDate,
  endDate,
}) {
  const dispatch = useDispatch();
  const [confirming, setConfirming] = useState(false);

  const handleRemove = () => {
    if (!confirming) {
      setConfirming(true);
      return;
    }
    dispatch(removeAdminImage({ id }));
  };

  const cancelRemove = () => setConfirming(false);

  return (
    <div className="flex items-center gap-4 p-4 !mt-2 bg-white shadow rounded-xl">
      <div className="text-sm font-mono text-gray-500">#{id}</div>

      <img
        src={src}
        alt={label}
        className="h-24 w-24 object-cover rounded border border-gray-200"
      />

      <div className="flex-1">
        <div className="text-lg font-semibold text-gray-800">{label}</div>
        {action && (
          <div className="text-sm text-gray-500 italic mt-1">{action}</div>
        )}
      </div>

      <div className="flex items-center gap-3">
        <button
          onClick={() =>
            onEdit({
              imageUrl: src,
              labelInit: label,
              startDateInit: startDate,
              endDateInit: endDate,
              searchString: action,
              id,
            })
          }
          className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
          title="Edit image"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="size-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M16.862 4.487l1.65-1.65a1.875 1.875 0 112.652 2.652l-1.65 1.65m-2.652-2.652L6.708 17.04a4.5 4.5 0 01-1.897 1.13l-2.137.534.534-2.137a4.5 4.5 0 011.13-1.897L16.862 4.487z"
            />
          </svg>
          <span className="text-sm">Edit</span>
        </button>

        {!confirming ? (
          <button
            onClick={handleRemove}
            className="text-red-600 hover:text-red-800 flex items-center gap-1"
            title="Remove image"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="size-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
              />
            </svg>
            <span className="text-sm">Remove</span>
          </button>
        ) : (
          <div className="flex items-center gap-2">
            <button
              onClick={handleRemove}
              className="text-red-600 font-medium text-sm hover:underline"
            >
              Are you sure?
            </button>
            <button
              onClick={cancelRemove}
              className="text-gray-500 text-sm hover:underline"
            >
              Cancel
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
